
import { defineComponent, PropType } from 'vue'

import { formatTime, localTime, UtcOffsetDisplay } from '../util'
import { TimeSlot, Store, Artist } from '../types'

export default defineComponent({
  name: 'TimeSlotItem',
  props: {
    timezone: {
      type: String,
      default: '',
    },
    emitter: {
      type: Object,
      required: true,
    },
    store: {
      type: Object as PropType<Store>,
      required: true,
    },
    item: {
      type: Object as PropType<TimeSlot>,
      required: true,
    },

    selected: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const getArtistById = (artistId: string): Artist => {
      const artistIndex = props.store.artistList.findIndex(
        artist => artist.id === parseInt(artistId),
      )
      return props.store.artistList[artistIndex]
    }

    const selectSlot = (slotId: number): void => {
      if (props.item.artistId) {
        props.emitter.emit('select-slot', slotId)
      }
    }

    const toggleSlot = (): void => {
      if (props.item.artistId) {
        if (props.selected) {
          props.emitter.emit('select-slot', -1)
        } else {
          props.emitter.emit('select-slot', props.item.id)
        }
      }
    }

    const setTz = ({ tz, offset }: { tz: string; offset: number }): void => {
      props.emitter.emit('set-tz', {
        tz,
        offset,
      })
    }

    const clearSlot = (): void => {
      if (props.item.artistId) {
        props.emitter.emit('clear-slot', props.item.id)
      }
    }

    const setLockStatus = (status: string): void => {
      props.emitter.emit('set-slot-status', { slotId: props.item.id, status: status })
    }

    return {
      formatTime,
      localTime,
      props,
      getArtistById,
      selectSlot,
      UtcOffsetDisplay,
      clearSlot,
      toggleSlot,
      setLockStatus,
      setTz,
    }
  },
})
